import React from 'react';
import classnames from 'classnames'
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getHostApi, apiPost } from '../../../store/apiWrapper';
import { monitoringActions } from '../../../store/monitoringStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { domainActions } from '../../../store/domainStore';
import { writeErr } from '../../common/logger';
import ModalInner from '../../layoutItems/modalInner';
import BbInput from '../../styling/bbInput';
import { validateInput } from '../../../store/storeFunctions';
import DeleteIcon from '../../../img/icons/BBiconsOdstranit';

import './searchSubjectPopup.scss';

class MoveSubjectPopup extends React.Component {
    mounted = false;

    state = {
        portfolios: [],
        selectedPortfolio: null,
        isLoading: false,
        createNew: false,
        newPortfolioName: "",
    };

    get isDisabled() {
        if (this.state.isLoading)
            return true;
        if (!this.state.createNew)
            return this.state.selectedPortfolio === null;
        else
            return this.state.newPortfolioName.length === 0;
    }

    render() {
        return (
            <ModalInner title={this.props.translate(this.props.mode === "MOVE" ? "Portfolio.Subjects.Move" : "Portfolio.Subjects.Copy")} close={() => this.props.close(true)}>
                <div className="move-subject-popup">
                    {this.state.isLoading && <div className="search-progress searching"></div>}
                    {this.renderDropdown()}
                    <div className="modal-inner-buttons">
                        <button onClick={() => this.confirmClick()} disabled={this.isDisabled}
                            className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        >
                            <Translate id="Common.Save" />
                        </button>
                    </div>
                </div>
            </ModalInner>
        );
    }

    componentDidMount() {
        this.mounted = true;
        this.setState({ isLoading: true });
        apiPost(`${getHostApi()}/api/portfolio/list`,
            null,
            { TypeId: this.props.portfolioType.toString(), Parent: "true" },
            (s) => {
                if (s.data.isSuccess)
                    this.mounted && this.setState({ isLoading: false, portfolios: s.data.items.filter(p => p.id !== this.props.portfolioId) });
                else {
                    this.mounted && this.setState({ isLoading: false });
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptioData(s.data.exceptionData)));
                    this.props.close(false);
                }
            },
            (e) => { this.mounted && this.setState({ isLoading: false }); writeErr(e); }
        );
    }

    componentWillUnmount() {
        this.mounted = false;
    }


    renderDropdown() {
        return (
            <>
                <BbInput type='select-noformik' label={this.props.translate('Portfolio.Choose')}
                    formatOptionLabel={(c) => this.formatOptionLabel(c)} placeholder={{ type: 'column' }}
                    options={this.getOptions()}
                    onChange={(e) => this.setState({ selectedPortfolio: e.value })}
                />
                <div className="columns" >
                    <div className="column" style={{ textAlign: "center" }}>
                        <Translate id="Common.Or" />
                    </div>
                </div>
                {this.state.createNew
                    ? <div className="columns">
                        <div className="column">
                            <div className="field bb-field">
                                <div className="control" data-error="false">
                                    <div className="columns">
                                        <div className="column bb-input-label-column is-one-third">
                                            <div className="vertically-centered">
                                                <span><Translate id="Monitoring.Add.PortfolioName" /></span>
                                            </div>
                                        </div>
                                        <div className="column bb-input-column is-two-thirds">
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <input type="text" className="input form-control"
                                                    placeholder={this.props.translate("Monitoring.Add.CreateNewPortfolio")}
                                                    onKeyDown={(e) => e.keyCode === 13 && this.createNewPortfolioWithSubjects()}
                                                    value={this.state.newPortfolioName}
                                                    onChange={(e) => this.setState({ newPortfolioName: e.target.value })}
                                                    onInput={(e) => validateInput(e)}
                                                />
                                                <span style={{ marginLeft: "1em" }}>
                                                    <DeleteIcon
                                                        className="portfolio-remove-icon"
                                                        title="Common.Button.Cancel"
                                                        onClick={() => this.setState({ createNew: false })}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <div className="columns">
                        <div className="column" style={{ textAlign: "center" }}>
                            <span onClick={() => this.setState({ createNew: true })} className="link-internal"><Translate id="Monitoring.Add.CreateNewPortfolio" /></span>
                        </div>
                    </div>
                }
            </>
        );
    }

    addSubjectsToPortfolio(portfolioId) {
        apiPost(`${getHostApi()}/api/portfolio/${this.props.portfolioId}/subjects/copy-to/${portfolioId}`, null, this.props.ids,
            (s) => {
                this.mounted && this.setState({ isLoading: false });
                if (s.data.isSuccess) {
                    this.props.changeMessage("success", this.props.translate('Portfolio.Search.PortfolioUpdated'));
                    this.props.close(false);
                    this.props.refresh();
                }
                else {
                    this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptioData(s.data.exceptionData)));
                    this.props.close(false);
                }
            },
            (e) => { this.mounted && this.setState({ isLoading: false }); writeErr(e); }
        );
    }

    confirmClick() {
        this.setState({ isLoading: true });
        if (!this.state.createNew) {
            apiPost(`${getHostApi()}/api/portfolio/${this.props.portfolioId}/subjects/${this.props.mode === "COPY" ? "copy-to" : "move-to"}/${this.state.selectedPortfolio}`,
                null,
                this.props.ids,
                (s) => {
                    this.mounted && this.setState({ isLoading: false });
                    if (s.data.isSuccess) {
                        this.props.changeMessage("success", this.props.translate('Portfolio.Search.PortfolioUpdated'));
                        this.props.close(false);
                        this.props.refresh();
                    } else {
                        this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptioData(s.data.exceptionData)));
                        this.props.close(false);
                    }
                },
                (e) => { this.mounted && this.setState({ isLoading: false }); writeErr(e); }
            )
        } else {
            this.props.createEmptyPortfolio(this.state.newPortfolioName, this.props.portfolioType,
                (s) => {
                    if (s.data.isSuccess)
                        this.addSubjectsToPortfolio(s.data.id);
                    else {
                        this.props.changeMessage("error", this.props.translate(s.data.exception, this.getExceptioData(s.data.exceptionData)));
                        this.props.close(false);
                    }
                },
                (e) => { this.mounted && this.setState({ isLoading: false }); writeErr(e); }
            );
        }
    }

    onCancelClick() {
        if (!this.state.createNew)
            this.props.close(true);
        else
            this.setState({ createNew: false, newPortfolioName: "" });
    }

    getOptions() {
        return this.state.portfolios.map(x => ({ value: x.id, label: x.name }));
    }

    formatOptionLabel = ({ value, label }) => {
        return (<div key={value} style={{ display: "flex" }}>
            <div>{label}</div>
        </div>);
    };

    getExceptioData = (e) => isNullOrUndefined(e) ? undefined : e;
}

export default withLocalize(connect(
    state => { return { domain: state.domain, monitoring: state.monitoring } },
    dispatch => bindActionCreators(Object.assign({}, domainActions, monitoringActions), dispatch)
)(MoveSubjectPopup));


